<template>
  <div class="loginregister">
    <div class="contain">
      <div class="text">
        <h1>Schedule a Demo.</h1>
        <p>
          Fill out the form and let's start a conversation!
        </p>
      </div>

      <div class="inputs contact-form">
        <div class="input full">
          <label>Company<span class="required">*</span></label>
          <input
            type="text"
            placeholder="Type here"
            v-model="contact.company"
          />
        </div>
        <div class="input">
          <label>First Name <span class="required">*</span></label>
          <input type="text" v-model="contact.first_name" />
        </div>
        <div class="input">
          <label>Last Name <span class="required">*</span></label>
          <input type="text" v-model="contact.last_name" />
        </div>
        <div class="input">
          <label>Email Address <span class="required">*</span></label>
          <input type="text" v-model="contact.email" />
        </div>
        <div class="input">
          <label>Phone Number <span class="required">*</span></label>
          <vue-tel-input v-model="contact.phone"></vue-tel-input>
        </div>

        <div class="btns right form-btn">
          <transition name="fade-quick">
            <div>
              <button
                @click="validate()"
                v-if="status == 'submit'"
                class="btn"
              >
                Reach Out
              </button>
              <transition name="fade-quick">
                <p v-if="feedback" class="error">{{ feedback }}</p>
              </transition>
            </div>
          </transition>
          <transition name="fade-quick">
            <img
              class="loader"
              v-if="status == 'loading'"
              src="@/assets/img/loader.gif"
            />
          </transition>
          <transition name="fade-quick">
            <div class="success" v-if="status == 'success'">
              <p>
                Thanks!
                <span>We'll get back to you shortly.</span>
              </p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;
export default {
  data() {
    return {
      contact: {
        first_name: null,
        last_name: null,
        email: null,
        company: null,
        phone: null,
      },
      status: "submit",
      feedback: "",
      sendEmail: functions.httpsCallable("sendEmail"),
    };
  },
  methods: {
    validate() {
      let valid = true;
      let contact = this.contact;

      for (let key in contact) {
        if (!contact[key]) valid = false;
      }

      if (valid) {
        this.sendContact();
      } else {
        this.feedback = "Please enter all required fields";
      }
    },
    sendContact() {
      this.status = null;
      this.feedback = null;

      this.sendEmail({
        template_name: "covid-19-send-contact",
        to_email: [
          {
            email: "eitan@emagid.com",
            type: "to",
          },
        ],
        from_email: null,
        global_merge_vars: [
          {
            name: "name",
            content: this.contact.first_name + " " + this.contact.last_name,
          },
          {
            name: "email",
            content: this.contact.email,
          },
          {
            name: "phone",
            content: this.contact.phone,
          },
          {
            name: "comments",
            content: this.contact.company,
          },
        ],
        message: null,
      })
        .then((response) => {
          setTimeout(() => {
            this.status = "success";
            this.contact = {
              first_name: null,
              last_name: null,
              email: null,
              phone: null,
              company: null,
            };
          }, 500);
        })
        .then(() => {
          setTimeout(() => {
            this.$router.push("/");
          }, 2000);
        })
        .catch(function(error) {
          console.log(error);
          Swal.fire("Could not send email");
        });
    },
  },
};
</script>

<style lang='scss'>
  .loginregister {
    min-height: 100vh;
    background: white;
    .contain {
      min-height: 100vh;
      align-items: center;
      flex-direction: row;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      @media screen and (max-width: 900px){
        min-height: auto;
        padding-top: 150px;
      }
      & > div {
        width: 48%;
        @media screen and (max-width: 900px){
          width: 100%;
        }
      }
    }
  }
</style>
